import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";
import useHttp from "../../../hook/use-http";
import SliderDefLevel from "./SliderDefLevel";

const Styles = styled.div`
  .rs-slider-vertical .rs-slider-bar {
    width: 9px;
    border-radius: 0px;
    height: 100%;
    position: relative;
  }

  .rs-slider-handle:before {
    height: 0px;
    border-radius: 0px;
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
    position: absolute;
    margin-left: -15px;
  }

  .rs-slider-handle input[type="range"] {
    display: none;
  }


  .rs-slider-vertical .rs-slider-progress-bar {
    width: 9px;
    border-radius: 0px;
  }

  .rs-slider-progress-bar {
    background-color: #95a5d5;
    bottom: 0%;
    height: 60%;
    position: absolute;
  }
`;

const DefLevel = ({ title, sign, gloablfilter }) => {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [defLevel, setDefLevel] = useState(0);
  const handleDefLevelProgress = (e) => {
    setDefLevel(e);
  };

  const appyData = (data) => {
    if (data.length > 0) {
      setDefLevel(data?.[0]?.fields?.State_of_Charge_SOC[0])
    } else {
      setDefLevel(0)
    }
  }

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "real_time_fault_code/soc_chart",
        body: { filterdata: gloablfilter },
      },
      appyData
    );
  }, [gloablfilter]);

  return (
    <div className="v-title boxDIC borderDownDIC p-0 indicator_lamp">
      <div className="titlebg boxTitleDIC pb-2 pt-2">{title}</div>
      <Styles>
        <div className="d-flex flex-column align-items-center justify-content-center bg-white" style={{ padding: "0rem 0rem 2rem 0", position: "relative" }} >
          <div className="d-flex" style={{ height: "200px" }}>
            <div style={{ width: "9px", height: "100% !important" }} >
              <div className="position-relative" style={{ height: "19%", backgroundColor: "green", }} >
                <span className="position-absolute bottom-0 fw-semibold text-secondary" style={{ left: "-20px", }} >
                  80
                </span>
              </div>
              <div className="position-relative" style={{ height: "19%", backgroundColor: "green", marginTop: "2px", }} >
                <span className="position-absolute bottom-0 fw-semibold text-secondary" style={{ left: "-20px", }} >
                  60
                </span>
              </div>
              <div className="position-relative mt-1" style={{ height: "19%", backgroundColor: "green", marginTop: "2px", }} >
                <span className="position-absolute bottom-0 fw-semibold text-secondary" style={{ left: "-20px", }} >
                  40
                </span>
              </div>
              <div className="position-relative mt-1" style={{ height: "19%", backgroundColor: "green", marginTop: "2px", }}>
                <span className="position-absolute bottom-0 fw-semibold text-secondary" style={{ left: "-20px", }}>
                  20
                </span>
              </div>
              <div className="position-relative mt-1" style={{ height: "19%", backgroundColor: "red", marginTop: "2px", }}>
                <span className="position-absolute bottom-0 fw-semibold text-secondary" style={{ left: "-15px", }}>
                  0
                </span>
              </div>
            </div>
            <SliderDefLevel className="ms-2" handleChange={handleDefLevelProgress} value={defLevel} />
          </div>
        </div>
        <div
          className="position-absolute d-flex flex-column align-items-start"
          style={{
            left: "calc(60% + 10px)", // Adjust this to control the horizontal spacing
            top: "50%", // Align vertically with the center of the chart
            transform: "translateY(-50%)", // Perfect vertical centering
          }}
        >
          <span className="fw-bold text-dark">
            <h2 className="m-0 vehicle_details_data">{defLevel}</h2>
          </span>
          <span className="fw-bold text-dark">
            <h2 className="m-0 vehicle_details_data">{sign}</h2>
          </span>
        </div>
      </Styles>
    </div>
  );
};

export default DefLevel;
